// Small presentational helpers shared by both pages.

export function bytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / 1024 / 1024).toFixed(1)} MB`;
  return `${(n / 1024 / 1024 / 1024).toFixed(2)} GB`;
}

/** ISO → "2026-08-24 22:18" in local time. */
export function stamp(iso: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  const p = (x: number) => String(x).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

export function clock(iso: string): string {
  const d = new Date(iso);
  const p = (x: number) => String(x).padStart(2, "0");
  return `${p(d.getHours())}:${p(d.getMinutes())}`;
}

const ONE_LINE = 140;
export function oneLine(v: unknown): string {
  const s = typeof v === "string" ? v : JSON.stringify(v);
  const flat = (s ?? "").replace(/\s+/g, " ").trim();
  return flat.length > ONE_LINE ? `${flat.slice(0, ONE_LINE)}…` : flat;
}

export const STATUS_LABEL = {
  idle: "idle",
  running: "running",
  awaiting_user: "awaiting user",
} as const;
